import { Component, OnInit, Input } from '@angular/core';
import { RelatedAnnouncement } from '../shared/models/similar-announcement-model';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/root-store/state';
import { setIsSimilarAnnouncement } from 'src/app/root-store/announcement-store/ann-details-page/actions';

@Component({
    selector: 'app-similar-ann-item',
    templateUrl: './redesign/similar-ann-item.component.html',
    styleUrls: ['./redesign/similar-ann-item.component.scss'],
    standalone: false
})
export class SimilarAnnItemComponent implements OnInit {

  @Input() similarAnnouncement: RelatedAnnouncement;

  constructor(private store: Store<AppState>) { }

  ngOnInit(): void {
  }

  onSimilarAnnouncement(){
      this.store.dispatch(setIsSimilarAnnouncement());
  }
}